import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Hourglass, CheckCircle2, Clock } from "lucide-react";
import { Button, Spinner } from "@/components/earnos/kit";
import { apiFetch } from "@/lib/api";
import { colors } from "@/lib/theme";

export default function ConnectReturn() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");
  const [due, setDue] = useState([]);

  const check = useCallback(async () => {
    setStatus("loading"); setError("");
    try {
      const res = await apiFetch("/connect/status");
      setDue(res.requirements_due || []);
      setStatus(!res.connected ? "disconnected" : res.payouts_enabled ? "active" : "pending");
    } catch (e) { setError(e.message || "Could not check payout status."); setStatus("error"); }
  }, []);
  useEffect(() => { check(); }, [check]);

  const cfg = {
    error: { Icon: Clock, color: colors.warning, title: "Payout status unavailable", msg: error },
    disconnected: { Icon: Clock, color: colors.warning, title: "Payout account is not connected", msg: "Return to Billing to connect your payout account." },
    loading: { Icon: Hourglass, color: colors.brandSecondary, title: "Checking your payout status…", msg: "" },
    active: { Icon: CheckCircle2, color: colors.success, title: "Payouts are active", msg: "You can now receive net payments from EARNOS-facilitated transactions." },
    pending: { Icon: Clock, color: colors.warning, title: "Almost there", msg: "Stripe still needs a few details before payouts are enabled. You can finish setup anytime from Billing." },
  }[status];

  const Icon = cfg.Icon;

  return (
    <div className="min-h-screen bg-surface flex flex-col items-center justify-center px-6 text-center">
      {status === "loading" ? <Spinner /> : (
        <div className="w-[88px] h-[88px] rounded-full flex items-center justify-center" style={{ backgroundColor: cfg.color + "22" }}><Icon size={44} style={{ color: cfg.color }} /></div>
      )}
      <h1 className="text-2xl font-extrabold text-ink mt-6">{cfg.title}</h1>
      {cfg.msg ? <p className="text-lg text-ink-2 mt-3 max-w-md leading-relaxed">{cfg.msg}</p> : null}
      {status === "pending" && due.length ? <p className="text-base text-warn mt-2">Needs: {due.slice(0, 4).join(", ")}</p> : null}
      <p className="text-sm text-ink-2 mt-4 max-w-md">Payout readiness is not proof of received payment. Payment totals require verified provider records.</p>
      {status === "error" && <Button title="Retry status check" onClick={check} className="mt-4" />}
      {status !== "loading" ? <Button title="Back to billing" onClick={() => navigate("/billing", { replace: true })} className="mt-6 min-w-[220px]" testID="connect-return-back" /> : null}
    </div>
  );
}
